import _ from 'lodash'

const filterTable = (source, tableFilter) => {


  if(_.isEmpty(tableFilter) || _.isEmpty(_.filter(tableFilter, (filters) => !_.isEmpty(filters))))
    return source

  const toLowerCaseString = _.flowRight([_.toLower, _.toString])

  return _.filter(source, (row) => {
    for(let columnKey in tableFilter) {
      const columnFilters = tableFilter[columnKey]
      if(!_.isEmpty(columnFilters) && !_.isEmpty(toLowerCaseString(row[columnKey]))
        && _.find(columnFilters, (filterVal) => (toLowerCaseString(filterVal) === toLowerCaseString(row[columnKey])))) {
        return true
      }
    }
    return false
  })
}

const sortTable = (source, tableSort) => {
  if(_.isEmpty(tableSort))
    return source

  const colKey = _.keys(tableSort)[0], colSortVal = tableSort[colKey]

  return _.orderBy(source, [colKey], [colSortVal])
}


module.exports = {
  filterTable,
  sortTable,
}